import type {ReactNode} from 'react'
import {Reveal} from '@/components/reveal'
import {cn} from '@/lib/utils'

/** Las únicas formas del CTA de la página; `grande` se reserva al héroe. */
export const CTA_BASE =
  'inline-flex min-h-11 items-center justify-center rounded-lg px-6 py-3 text-sm font-semibold transition-colors'
export const CTA_SELLO = `${CTA_BASE} bg-primary text-primary-foreground shadow-button hover:bg-primary-hover`
export const CTA_LINEA = `${CTA_BASE} border border-primary text-primary hover:bg-accent`
export const CTA_SELLO_GRANDE =
  'inline-flex min-h-13 items-center justify-center rounded-lg bg-primary px-8 py-4 text-base font-semibold text-primary-foreground shadow-button transition-colors hover:bg-primary-hover'

export function PautaEyebrow({children, onInk}: {children: ReactNode; onInk?: boolean}) {
  return (
    <div className="flex items-center gap-3">
      <span
        aria-hidden="true"
        className={cn('h-1.5 w-1.5 shrink-0 rounded-full', onInk ? 'bg-primary-foreground' : 'bg-primary')}
      />
      <p
        className={cn(
          'font-mono text-[11px] font-semibold tracking-[0.14em] uppercase',
          onInk ? 'text-ink-deep-foreground/70' : 'text-primary'
        )}>
        {children}
      </p>
      <span aria-hidden="true" className={cn('h-px min-w-6 flex-1', onInk ? 'bg-hairline-on-ink' : 'bg-border')} />
    </div>
  )
}

export function SeccionHead({
  eyebrow,
  title,
  body,
  onInk,
  className,
}: {
  eyebrow: string
  title: string
  body?: string
  onInk?: boolean
  className?: string
}) {
  return (
    <Reveal className={className}>
      <PautaEyebrow onInk={onInk}>{eyebrow}</PautaEyebrow>
      <h2
        className={cn(
          'mt-5 max-w-2xl font-heading text-3xl tracking-tight sm:text-[2.5rem] sm:leading-[1.1]',
          onInk ? 'text-ink-deep-foreground' : 'text-foreground'
        )}>
        {title}
      </h2>
      {body && (
        <p className={cn('mt-4 max-w-2xl text-base', onInk ? 'text-ink-deep-foreground/70' : 'text-muted-foreground')}>
          {body}
        </p>
      )}
    </Reveal>
  )
}
